/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Container, Stack, TextField, Typography } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import { m } from 'framer-motion';
import { useEffect, useState } from 'react';
import licenseDetails from '../../assets/licenseDetails.json';
import { MotionViewport, varFade } from '../../components/animate';
import useLocales from "../../hooks/useLocales";
import { setLicenseData } from '../../redux/slices/gplx.quiz';
import { useDispatch, useSelector } from '../../redux/store';

export function Exam200Header() {
  const { translate } = useLocales();

  return <Container component={MotionViewport} sx={{ mb: 5 }}>
    <m.div variants={varFade().inDown}>
      <Stack spacing={3}>
        <Typography variant={"h2"} textAlign={"center"} textTransform={"capitalize"}>
          {translate('bike.title')} {new Date().getMonth() + 1}/{new Date().getFullYear()}
        </Typography>
        <SelectSmall />
      </Stack>
    </m.div>
  </Container>;
}
function SelectSmall() {
  const dispatch = useDispatch();
  const { licenseIndex } = useSelector((state) => state.exam);
  const [license, setLicense] = useState(checkLicenseIndex(licenseIndex));
  function checkLicenseIndex(licenseIndex) {
    if (licenseIndex >= 4) {
      return 0;
    }
    else {
      return licenseIndex;
    }
  }
  useEffect(() => {
    const licenseDetail = licenseDetails[license];
    dispatch(setLicenseData({
      licenseIndex: license,
      licenseName: licenseDetail.name,
      licenseRequirement: {
        time: licenseDetail.time,
        correctAnswers: licenseDetail.correctAnswers,
      },
      totalExams: licenseDetail.totalExams
    }
    ));
    setLicense(license);
  }, [license]);
  const handleChange = (event) => {
    const licenseDetail = licenseDetails[event.target.value];
    setLicense(event.target.value);
    dispatch(setLicenseData({
      licenseIndex: event.target.value,
      licenseName: licenseDetail.name,
      licenseRequirement: {
        time: licenseDetail.time,
        correctAnswers: licenseDetail.correctAnswers,
      },
      totalExams: licenseDetail.totalExams
    }
    ));
  };

  return (
    <Stack alignItems={"center"}>
      <Box my={1}>
        <FormControl size="medium" sx={{ minWidth: 200 }}>
          <TextField variant="outlined" select size="medium" onChange={handleChange} value={license}>
            <MenuItem value={0}>Hạng _ A1</MenuItem>
            <MenuItem value={1}>Hạng _ A2</MenuItem>
            <MenuItem value={2}>Hạng _ A3</MenuItem>
            <MenuItem value={3}>Hạng _ A4</MenuItem>
          </TextField>
        </FormControl>
      </Box>
    </Stack>
  );
}